<style>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}
.required_err {
  color: rgba(255, 0, 0);
}

.rc_td_bottom {
    border-top: none !important;
    border-right: none !important;
    border-left: none !important;
    border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}

.rc_td_no_borders {
    border-top: none !important;
    border-right: none !important;
    border-left: none !important;
    border-bottom: none !important;
}

tr:hover {
    background-color: transparent !important;
}

.br_rd_odd {
    background-color: rgba(0, 0, 0, .03) !important;
}

.rc_section {
    padding-top: 12px;
}

.br {
    color: rgba(109, 103, 164);
}

.br_section {
    padding-bottom: 16px;
}

.br_checkbox {
    font-size: 14px !important;
}

</style>

<template>
    <div class="ip_pool">
        <v-toolbar flat>
            <v-toolbar-title><h2 class="br">SNAT44 maps</h2></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="nat3_map_form__show"
                    color="primary" dark class="mb-2">
                    Add SNAT44 map
            </v-btn>
        </v-toolbar>

        <v-simple-table>
            <template v-slot:default>

<v-dialog v-model="new_nat3_map_dialog" max-width="800px">
    <ValidationObserver ref="new_nat3_map_observer" v-slot="{ invalid }">
    <v-card>
        <v-card-title>
            <span class="headline">{{ nat3_map_form_caption }}</span>
        </v-card-title>

        <v-card-text>
            <v-container style="height: 520px; overflow-y: scroll;">
                <v-row>
                    <v-col cols="12">
                        <ValidationProvider rules="required|numeric|snat44_map_id" v-slot="{ errors }">
                                <v-text-field
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.map_id"
                                    label="Map ID">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <ValidationProvider rules="numeric" v-slot="{ errors }">
                                <v-text-field
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.max_internal_hosts"
                                    :label="'Max internal hosts (optional, default value ' + 
                                        map_defaults.max_internal_hosts + ')'">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <ValidationProvider rules="numeric" v-slot="{ errors }">
                                <v-text-field
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.max_sessions"
                                    :label="'Max NAT translation sessions (optional, default value ' + 
                                        map_defaults.max_sessions + ')'">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <ValidationProvider rules="numeric" v-slot="{ errors }">
                                <v-text-field
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.port_block_size"
                                    :label="'Port block size (optional, default value ' + 
                                        map_defaults.port_block_size + ')'">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <ValidationProvider rules="numeric" v-slot="{ errors }">
                                <v-text-field
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.port_blocks_per_in_address"
                                    :label="'Port blocks per internal host (optional, default value ' + 
                                        map_defaults.port_blocks_per_in_address + ')'">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <ValidationProvider rules="numeric" v-slot="{ errors }">
                                <v-text-field
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.in_out_ratio"
                                    :label="'In/out ratio (optional, default value ' + 
                                        map_defaults.in_out_ratio + ')'">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>                        

                        <div v-if="edited_index !== -1" class="br_section">
                            <v-checkbox v-model="edited_item.nel_session">
                                <template v-slot:label>
                                    <span class="br_checkbox">NEL sessions</span>
                                </template>
                            </v-checkbox>

                            <v-checkbox v-model="edited_item.nel_port_block">
                                <template v-slot:label>
                                    <span class="br_checkbox">NEL port-blocks</span>
                                </template>
                            </v-checkbox>

                            <div class="rc_section">
                                <v-toolbar flat>
                                    <v-toolbar-title>Internal prefixes</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="internal_prefix_add_form()">Add</v-btn>
                                </v-toolbar>
                                <v-data-table
                                        :headers="internal_prefix_hdrs"
                                        :items="edited_item.internal_prefixes"
                                        sort-by="prefix"
                                        hide-default-footer
                                        class="elevation-1">
                                    <template v-slot:item.actions="{ item }">
                                        <v-icon small @click="internal_prefix_del(item)">
                                            mdi-delete
                                        </v-icon>
                                    </template>
                                    <template v-slot:no-data>
                                        No records
                                    </template>
                                </v-data-table>
                            </div>

                            <div class="rc_section">
                                <v-toolbar flat>
                                    <v-toolbar-title>Out IP addresses</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="out_range_form_show()">Add</v-btn>
                                </v-toolbar>
                                <v-data-table
                                        :headers="out_ip_range_hdrs"
                                        :items="edited_item.out_ranges"
                                        sort-by="from"
                                        hide-default-footer
                                        class="elevation-1">
                                    <template v-slot:item.actions="{ item }">
                                        <v-icon small @click="out_range_del(item)">
                                            mdi-delete
                                        </v-icon>
                                    </template>
                                    <template v-slot:no-data>
                                        No records
                                    </template>
                                </v-data-table>
                            </div>

                            <div class="rc_section">
                                <v-toolbar flat>
                                    <v-toolbar-title>Statistic</v-toolbar-title>
                                </v-toolbar>

                                <v-text-field
                                    v-bind:readonly="true"
                                    v-model="edited_item.active_sessions"
                                    label="Active sessions"
                                ></v-text-field>

                                <v-data-table
                                    v-bind:readonly="true"
                                    :headers="state_counters_hdrs"
                                    :items="edited_item.state_counters"
                                    :search="search"
                                    sort-by="state"
                                    hide-default-footer
                                    class="elevation-1"
                                >
                                </v-data-table>
                            </div>
                        </div>

                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" :disabled="invalid" text @click="nat3_map_form__save">Save</v-btn>
            <v-btn color="blue darken-1" text @click="nat3_map_form__close">Close</v-btn>
        </v-card-actions>
    </v-card>
    </ValidationObserver>
</v-dialog>

<v-dialog v-model="internal_prefix_dialog" max-width="500px">
    <ValidationObserver ref="internal_prefix_observer" v-slot="{ invalid }">
    <v-card>
        <v-card-title>
            <span class="headline">Add internal prefix to SNAT44 map {{ edited_item.map_id }}</span>
        </v-card-title>
        <v-card-text>
            <v-container style="height: 520px; overflow-y: scroll;">
                <v-row>
                    <v-col cols="12">
                        <ValidationProvider rules="required|ipv4_prefix" v-slot="{ errors }">
                            <v-text-field
                                v-model="internal_prefix"
                                label="Internal prefix">
                            </v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </v-col>
                </v-row>  
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="internal_prefix_form_close">
                Cancel</v-btn>
            <v-btn color="blue darken-1" :disabled="invalid" text @click="internal_prefix_form_save">
                Save</v-btn>
        </v-card-actions>
    </v-card>
    </ValidationObserver>
</v-dialog>

<v-dialog v-model="out_range_dialog" max-width="500px">
    <ValidationObserver ref="out_range_observer" v-slot="{ invalid }">
    <v-card>
        <v-card-title>
            <span class="headline">Add out ip range to SNAT44 map {{ edited_item.map_id }}</span>
        </v-card-title>
        <v-card-text>
            <v-container style="height: 520px; overflow-y: scroll;">
                <v-row>
                    <v-col cols="12">
                        <ValidationProvider rules="required|ipv4_addr" v-slot="{ errors }">
                            <v-text-field
                                v-model="out_range_from"
                                label="From address">
                            </v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <ValidationProvider rules="required|ipv4_addr" v-slot="{ errors }">
                            <v-text-field
                                v-model="out_range_to"
                                label="To address">
                            </v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </v-col>
                </v-row>  
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="out_range_form_close">
                Cancel</v-btn>
            <v-btn color="blue darken-1" :disabled="invalid" text @click="out_range_form_save">
                Save</v-btn>
        </v-card-actions>
    </v-card>
    </ValidationObserver>
</v-dialog>

            <thead>
                <tr>
                    <th class="text-left">
                        Map ID
                    </th>
                    <th class="text-left">
                        Internal Prefixes
                    </th>
                    <th class="text-left">
                        Out IP address ranges
                    </th>
                    <th class="text-left">
                        Max internal hosts
                    </th>
                    <th class="text-left">
                        Max sessions
                    </th>
                    <th class="text-left">
                        In/out ratio
                    </th>
                    <th class="text-left">
                        Port block size
                    </th>
                    <th class="text-left">
                        Port blocks per internal host
                    </th>
                    <th class="text-left">
                        NEL sessions
                    </th>
                    <th class="text-left">
                        NEL port blocks
                    </th>
                    <th class="text-left">
                        Actions
                    </th>
                </tr>
            </thead>
            <tbody>
                <template v-for="item,row_ind in items">
                    <tr v-for="(n,ind) in item.num_rows" :key="item.name + ':' + n">
                        <td v-if="ind == 0" :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(item)" 
                            :rowspan="item.num_rows">{{ item.map_id }}</td>

                        <td :class="tbl_td_class(item, ind, row_ind)" v-if="item.internal_prefixes[ind] !== undefined"
                                @dblclick="edit_item(item)">
                            {{ item.internal_prefixes[ind].prefix }}
                        </td>
                        <td :class="tbl_td_class(item, ind, row_ind)" @dblclick="edit_item(item)" v-else></td>

                        <td :class="tbl_td_class(item, ind, row_ind)" v-if="item.out_ranges[ind] !== undefined"
                                @dblclick="edit_item(item)">
                            {{ item.out_ranges[ind].from }} - {{ item.out_ranges[ind].to }}
                        </td>
                        <td :class="tbl_td_class(item, ind, row_ind)" @dblclick="edit_item(item)" v-else></td>

                        <td v-if="ind == 0"
                            :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(item)" 
                            :rowspan="item.num_rows">{{ item.max_internal_hosts }}</td>
                        <td v-else-if="ind == 0" :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(item)" 
                            :rowspan="item.num_rows"></td>

                        <td v-if="ind == 0"
                            :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(item)" 
                            :rowspan="item.num_rows">{{ item.max_sessions }}</td>
                        <td v-else-if="ind == 0" :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(item)" 
                            :rowspan="item.num_rows"></td>

                        <td v-if="ind == 0"
                            :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(item)" 
                            :rowspan="item.num_rows">{{ item.in_out_ratio }}</td>
                        <td v-else-if="ind == 0" :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(item)" 
                            :rowspan="item.num_rows"></td>

                        <td v-if="ind == 0"
                            :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(item)" 
                            :rowspan="item.num_rows">{{ item.port_block_size }}</td>
                        <td v-else-if="ind == 0" :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(item)" 
                            :rowspan="item.num_rows"></td>

                        <td v-if="ind == 0"
                            :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(item)" 
                            :rowspan="item.num_rows">{{ item.port_blocks_per_in_address }}</td>
                        <td v-else-if="ind == 0" :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(item)" 
                            :rowspan="item.num_rows"></td>

                        <td v-if="ind == 0"
                            :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(item)" 
                            :rowspan="item.num_rows">{{ item.nel_session_s }}</td>
                        <td v-else-if="ind == 0" :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(item)" 
                            :rowspan="item.num_rows"></td>

                        <td v-if="ind == 0"
                            :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(item)" 
                            :rowspan="item.num_rows">{{ item.nel_port_block_s }}</td>
                        <td v-else-if="ind == 0" :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(item)" 
                            :rowspan="item.num_rows"></td>

                        <td v-if="ind == 0" :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" :rowspan="item.num_rows">
                            <v-icon small class="me-2" @click="edit_item(item)">
                                mdi-pencil
                            </v-icon>
                            <v-icon small @click="before_delete_item(item)">
                                mdi-delete
                            </v-icon>
                        </td>                        
                    </tr>
                </template>
            </tbody>
            </template>
        </v-simple-table>
    </div>
</template>

<script>

import api_client from '../services/api.js';
import vif_ip_addr_box from "../components/vif_ip_addr_box.vue";
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import "../validation_rules.js";
import br_simple_table from "../simple_table.js";

extend('snat44_map_id', {
    message: 'Incorrect map id. Valid range is 0 - 4096.',
    validate: value => (value >= 0 && value <= 4096)
});

export default {
    name: 'nat3',
    components: {
        ValidationObserver, ValidationProvider, vif_ip_addr_box
    },

    mixins: [
        br_simple_table,
    ],

    data: () => ({
        save_ind: -1,
        saves: ["nel_session", "nel_port_block"],

        new_nat3_map_dialog: false,

        map_defaults: {
            max_internal_hosts: 32768,
            max_sessions: 8388608,
            port_block_size: 128,
            port_blocks_per_in_address: 4,
            in_out_ratio: 256,
        },

        deleted_ind: -1,
        deleted_item: {},

        edited_item_old: {},
        edited_item: {},
        items: [],

        state_counters_hdrs: [
            { text: 'NAT state', value: 'state', align: 'start' },
            { text: 'Counter', value: 'cnt' },
        ],

        internal_prefix_dialog: false,
        internal_prefix: '',
        internal_prefix_hdrs: [
            { text: 'Prefix', value: 'prefix', align: 'start' },
            { text: 'Actions', value: 'actions', sortable: false },
        ],

        out_range_dialog: false,
        out_range_from: '',
        out_range_to: '',
        out_ip_range_hdrs: [
            { text: 'From IP', value: 'from', align: 'start' },
            { text: 'To IP', value: 'to', align: 'start' },
            { text: 'Actions', value: 'actions', sortable: false },
        ],
    }),

    created() {
        this.initialize();
    },

    methods: {
        calculate_fields() {
            this.items.forEach(item => {
                let l = 1;

                l = Math.max(l, item.internal_prefixes.length);
                l = Math.max(l, item.out_ranges.length);
                item["num_rows"] = l;

                if (item.nel_session === 1) {
                    item["nel_session_s"] = "yes";
                }
                else {
                    item["nel_session_s"] = "no";
                }

                if (item.nel_port_block === 1) {
                    item["nel_port_block_s"] = "yes";
                }
                else {
                    item["nel_port_block_s"] = "no";
                }

            });
        },

        initialize() {
            return new Promise((resolve, reject) => {
                api_client.run_get_query("/nat/snat44/show")
                .then(response => {
                    this.items = response.data;
                    this.calculate_fields();
                    resolve(response);
                })
                .catch(error => {
                    console.log(error);
                });
            });
        },

        nat3_map_form__show() {
            this.edited_index = -1;
            this.nat3_map_form_caption = "New SNAT44 map";
            this.edited_item = {
                map_id: '',
                max_internal_hosts: '',
                max_sessions: '',
                port_block_size: '',
                in_out_ratio: '',
                port_blocks_per_in_address: '',
            };
            requestAnimationFrame(() => {
                this.$refs.new_nat3_map_observer.reset();
            });          
            this.new_nat3_map_dialog = true;
        },

        nat3_map_form__close() {
            this.new_nat3_map_dialog = false;
            this.initialize();
        },

        on_update_completed() {
            this.nat3_map_form__close();
        },

        update_cb() {
            let key = this.saves[this.save_ind];
            this.save_ind++;
            let url = "";
            let data = {};

            if (this.edited_item_old[key] !== this.edited_item[key]) {
                switch (key) {
                case "nel_session":
                    url = "/nat/snat44/nel_sess";
                    data["map_id"] = this.edited_item.map_id;
                    data["state"] = this.edited_item.nel_session;
                    break;
                case "nel_port_block":
                url = "/nat/snat44/nel_port_block";
                    data["map_id"] = this.edited_item.map_id;
                    data["state"] = this.edited_item.nel_port_block;
                    break;
                };

                if (url !== "") {
                    api_client.run_post_query(url, data)
                    .then(response => {
                        if (response.data.hasOwnProperty("err_msg")) {
                            this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                        }
                        else {
                            if (this.save_ind == this.saves.length) {
                                this.on_update_completed();
                            }
                            else {
                                this.update_cb();
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        this.$fire({title: "Command failed", text: error, type: "warning"});
                    });
                    
                    return;
                }
            }

            if (this.save_ind == this.saves.length) {
                this.on_update_completed();
            }
            else {
                this.update_cb(); 
            }
        },

        update_map() {
            this.save_ind = 0;
            this.update_cb();
        },

        save_new_map() {
            let new_item = {
                map_id: this.edited_item.map_id,
            };
            if (this.edited_item.max_internal_hosts != '') {
                new_item["max_internal_hosts"] = this.edited_item.max_internal_hosts;
            }
            if (this.edited_item.max_sessions != '') {
                new_item["max_sessions"] = this.edited_item.max_sessions;
            }
            if (this.edited_item.in_out_ratio != '') {
                new_item["in_out_ratio"] = this.edited_item.in_out_ratio;
            }
            if (this.edited_item.port_block_size != '') {
                new_item["port_block_size"] = this.edited_item.port_block_size;
            }
            if (this.edited_item.port_blocks_per_in_address != '') {
                new_item["port_blocks_per_in_address"] = this.edited_item.port_blocks_per_in_address;
            }

            api_client.run_post_query('/nat/snat44/add_map', new_item)
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.nat3_map_form__close();
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });            
        },

        nat3_map_form__save() {
            if (this.edited_index === -1) {
                this.save_new_map();
            }
            else {
                this.update_map();
            }
        },

        edit_item(item) {
            this.edited_index = this.items.indexOf(item);
            this.edited_item = Object.assign({}, item);
            this.edited_item_old = Object.assign({}, item);
            requestAnimationFrame(() => {
                this.$refs.new_nat3_map_observer.reset();
            });
            this.nat3_map_form_caption = "SNAT44 map";
            this.new_nat3_map_dialog = true;
        },

        before_delete_item(item) {
            this.edited_item = Object.assign({}, item);
            this.$confirm("Are you sure you want to delete SNAT44 map " + item.map_id + " ?")
            .then(() => {
                this.delete_item()
            });
        },

        delete_item() {
            api_client.run_post_query('/nat/snat44/del_map', {
                map_id: this.edited_item.map_id
            })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    /* success */
                    this.initialize();
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        },

        /*
         * Internal prefixes
         */
        internal_prefix_add_form() {
            this.internal_prefix = '';
            requestAnimationFrame(() => {
                this.$refs.internal_prefix_observer.reset();
            });          
            this.internal_prefix_dialog = true;
        },

        internal_prefix_form_close() {
            this.internal_prefix_dialog = false;
        },

        internal_prefix_form_save() {
            api_client.run_post_query('/nat/snat44/internal_prefix_add', {
                map_id: this.edited_item.map_id,
                prefix: this.internal_prefix,
            })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.edited_item.internal_prefixes.push({
                        prefix: this.internal_prefix
                    });
                    this.internal_prefix_form_close();
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        },

        internal_prefix_del(item) {
            this.deleted_ind = this.edited_item.internal_prefixes.indexOf(item);
            this.deleted_item = Object.assign({}, item);
            this.$confirm("Are you sure you want to delete internal prefix " + item.prefix +
                      " from map " + this.edited_item.map_id + " ?")
            .then(() => {
                this.internal_prefix_del_confirm();
            });
        },

        internal_prefix_del_confirm() {
            api_client.run_post_query('/nat/snat44/internal_prefix_del', {
                map_id: this.edited_item.map_id,
                prefix: this.deleted_item.prefix,
            })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.edited_item.internal_prefixes.splice(this.deleted_ind, 1);
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        },

        /*
         * Out ranges
         */
         out_range_form_show() {
            this.out_range_from = '';
            this.out_range_to = '';
            requestAnimationFrame(() => {
                this.$refs.out_range_observer.reset();
            });          
            this.out_range_dialog = true;
        },

        out_range_form_close() {
            this.out_range_dialog = false;
        },

        out_range_form_save() {
            api_client.run_post_query('/nat/snat44/out_range_add', {
                map_id: this.edited_item.map_id,
                from_addr: this.out_range_from,
                to_addr: this.out_range_to,
            })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.edited_item.out_ranges.push({
                        from: this.out_range_from,
                        to: this.out_range_to
                    });
                    this.out_range_form_close();
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        },

        out_range_del(item) {
            this.deleted_ind = this.edited_item.out_ranges.indexOf(item);
            this.deleted_item = Object.assign({}, item);
            this.$confirm("Are you sure you want to delete out range " + item.from + " - " + item.to +
                      " from map " + this.edited_item.map_id + " ?")
            .then(() => {
                this.out_range_del_confirm();
            });
        },

        out_range_del_confirm() {
            api_client.run_post_query('/nat/snat44/out_range_del', {
                map_id: this.edited_item.map_id,
                from_addr: this.deleted_item.from,
                to_addr: this.deleted_item.to,
            })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.edited_item.out_ranges.splice(this.deleted_ind, 1);
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        },        
    }
};
</script>
